import { extractPayloadFromEvent } from '../editor/payloadHelpers';
import { isPayloadSubmittable } from '../editor/editorState';
import { generateDxReportPdf } from '../dx-report-pdf';
import {
    approveDxReportFromReview,
    fetchDxReportDrafts
} from '../../../../../services/clinicalDrafts';
import type { TimelineEvent } from '../../types';

/**
 * One-click approve for the Review-Dx work-queue step: builds the same
 * payload/PDF the wizard would produce with zero edits, then submits it
 * through the same approve endpoint - a shortcut, not a different code path.
 */
export async function approveDraftFromLanding(
    patientId: string,
    draftId: string
): Promise<TimelineEvent> {
    // The draft stays editable until approved, so publish what's stored now, not a cached copy.
    const draft = (await fetchDxReportDrafts(patientId)).find((d) => d.id === draftId);
    if (!draft) {
        throw new Error('This draft is no longer available - refresh and try again.');
    }
    const payload = extractPayloadFromEvent(draft);
    if (!payload) {
        throw new Error('This draft has no content to approve.');
    }
    if (!isPayloadSubmittable(payload)) {
        throw new Error('This draft is missing required fields - open Review to complete it.');
    }
    const pdf = await generateDxReportPdf(payload);
    return approveDxReportFromReview({
        patientId,
        draftId,
        formData: payload,
        pdf,
        patientName: payload.patientInfo.patientName
    });
}
